import { UserImage } from "@circleco/ui-kit";
import type { UserImageSizes } from "@circleco/ui-kit/dist/src/lib/components/UserImage/constants";
import { useCurrentCommunityMember } from "@circle-react/contexts";

interface CurrentCommunityMemberAvatarProps {
  hasBorder?: boolean;
  size?: UserImageSizes;
}

export const CurrentCommunityMemberAvatar = ({
  size = "8",
  hasBorder = false,
}: CurrentCommunityMemberAvatarProps) => {
  const communityMember = useCurrentCommunityMember();

  if (!communityMember) {
    return null;
  }

  return (
    <UserImage
      name={communityMember.name}
      src={communityMember.avatar_url}
      size={size}
      isFullRounded
      hasBorder={hasBorder}
    />
  );
};
